<template>
    <div id="main">
        <div class="page">
            <loader v-if="isLoading" />
            <alert-container :messages="msgs" />
            <div class="novo-permissao">
                <h1 class="title">{{ $t('grupopermissao') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <router-link :to="'/conta/escolher-permissao'">{{
                                $t('settings')
                            }}</router-link>
                        </li>
                        <li>
                            <router-link :to="'/conta/grupo-permissoes'">{{
                                $t('grupopermissao')
                            }}</router-link>
                        </li>
                        <li>
                            <a href="#" aria-current="page">{{ permissao.descricao }}</a>
                        </li>
                    </ul>
                </nav>
                <div class="center">
                    <div class="form">
                        <div class="descricao-input">
                            <v-input
                                v-model="permissao.descricao"
                                :id="'nome'"
                                :placeholder="'usuario-nome-placeholder'"
                                :maxlength="100"
                                :title="'usuario-nome'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!permissao.descricao"
                                ref="descricaoInput"
                            />
                        </div>
                        <div class="switch-permissoes">
                            <fSwitch
                                :text="$t('permiteagro')"
                                :checked="permissao.permiteagro"
                                @change="permissao.permiteagro = $event"
                                disabled
                            />
                            <fSwitch
                                :text="$t('permitevendas')"
                                :checked="permissao.permitevendas"
                                @change="permissao.permitevendas = $event"
                            />
                            <fSwitch
                                :text="$t('permitepromotor')"
                                :checked="permissao.permitepromotor"
                                @change="permissao.permitepromotor = $event"
                            />
                        </div>
                        <div class="assusuario">
                            <SelectUsuario v-if="permissao.usuarios" :list="permissao.usuarios" />
                        </div>
                    </div>
                </div>
                <div class="form-buttons">
                    <button class="delete-btn" type="button" @click="$router.go(-1)">
                        {{ $t('voltar') }}
                    </button>
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$route.params.id ? carregarDados($route.params.id) : clearFields()"
                    >
                        {{ $t('cancelar') }}
                    </button>
                    <button class="save-btn" type="button" @click="save()" :disabled="isSaving">
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GrupoPermissaoService from '@/services/GrupoPermissaoService';
import GrupoPermissaoValidation from '@/services/validations/GrupoPermissaoValidation';
import SelectUsuario from '@/components/colaborador/SelectUsuario';
import fSwitch from '@/components/shared/form/Switch.vue';
import Message from '@/models/Message';

export default {
    components: {
        fSwitch,
        SelectUsuario,
    },
    data() {
        return {
            isSaving: false,
            isLoading: false,
            permissao: {
                usuario: {},
            },
            editable: false,
            title: '',
            msgs: [],
        };
    },
    created() {
        if (this.permissao != null && this.permissao != {}) {
            this.editable = true;
        }

        this.service = new GrupoPermissaoService(this.$http, this.$router);
        this.validation = new GrupoPermissaoValidation(this.msgs);

        if (this.$route.params.id) {
            this.editable = false;
            this.carregarDados(this.$route.params.id);
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.permissao = {};
            this.service.find(id).then((body) => {
                this.isLoading = false;
                if (body.content) {
                    this.permissao = body.content;

                    // Se agro for implementado, remover isto
                    this.permissao.permiteagro = false;
                } else {
                    this.$router.push({ name: 'grupopermissoes' });
                }
            });
        },
        save(redirect = this.redirectToList) {
            this.permissao = this.mapTosave(this.permissao);
            if (this.validation.validate(this.permissao, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.permissao)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-permissao-salva';
                            if (this.permissao.id) {
                                msg = 'msg-permissao-edita';
                            }
                            this.permissao = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            redirect(2);
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'grupopermissoes',
                });
            }, time * 1000 + 50);
        },
        redirectToEdit(time) {
            setTimeout(() => {
                this.$router.push({
                    name: 'edit-grupopermissao',
                    params: { id: this.permissao.idmotivofoto },
                });
            }, time * 1000 + 50);
        },
        clearFields() {
            this.permissao = {};
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    padding: 20px;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 80px;

    .assusuario {
        width: 100%;
        margin-top: 8px;
    }

    .novo-permissao {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;

        h1.title {
            padding-top: 0;
        }
    }
}

.form-buttons {
    top: 0;
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.novo-permissao .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 60px;
}

.novo-permissao .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .descricao-input {
        width: 100%;
    }
    .switch-permissoes {
        width: 100%;
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
    }

    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        margin-top: 20px;
        position: relative;
        min-height: 300px;
        height: auto;
        margin-bottom: 20px;

        .getlocation {
            position: absolute;
            margin-left: 0;
            bottom: -60px;
        }
    }
}
</style>
